/** A Discord league's table, and the season's best Pokémon by kills (worked out on the server, from matches that are over) */
import type { PokemonData } from '@ogreclan/pokemon-core';
import type { BotLeague } from '../api';
import { BotMon } from './discord-league';

export function BotStandings({ league, data }: { league: BotLeague, data: PokemonData | null }) {
	const yours = new Set(league.pools.map(pool => pool.you).filter(id => id !== null));
	const nameOf = (player: number) => league.standings.find(s => s.player === player)?.name ?? 'Someone';
	const top = league.topPokemon.slice(0, 15);
	const diff = (n: number) => `${n > 0 ? '+' : ''}${n}`;
	return <>
		<div class="card">
			<h2 style="margin-top:0">Standings</h2>
			<div class="table-wrap"><table>
				<thead><tr><th class="num">#</th><th>Player</th><th class="num">Played</th><th class="num">W</th><th class="num">L</th>
					<th class="num">Games</th><th class="num">Kills</th><th class="num">Deaths</th><th class="num">+/−</th></tr></thead>
				<tbody>{league.standings.map((s, i) => <tr key={s.player} class={yours.has(s.player) ? 'you' : ''}>
					<td class="num">{i + 1}</td><td>{s.name}</td><td class="num">{s.played}</td><td class="num">{s.wins}</td>
					<td class="num">{s.losses}</td><td class="num">{s.gameWins}–{s.gameLosses}</td>
					<td class="num">{s.kills}</td><td class="num">{s.deaths}</td>
					<td class="num" title={s.forfeitKd ? `${diff(s.forfeitKd)} from forfeits` : undefined}>{diff(s.diff)}{s.forfeitKd ? '*' : ''}</td>
				</tr>)}</tbody>
			</table></div>
			<p class="muted small">Ranked by wins, then fewest losses, kills minus deaths, and games won minus lost. A match counts
				once it's decided. *A forfeit counts as +6 for the winner and −6 for the player who forfeited.</p>
		</div>
		<div class="card">
			<h2 style="margin-top:0">Top Pokémon</h2>
			{top.length ? <div class="table-wrap"><table>
				<thead><tr><th>Pokémon</th><th>Player</th><th class="num">Games</th><th class="num">Kills</th><th class="num">Deaths</th></tr></thead>
				<tbody>{top.map(s => <tr key={`${s.player}:${s.pokemon}`} class={yours.has(s.player) ? 'you' : ''}>
					<td><BotMon data={data} name={s.pokemon} /></td><td>{nameOf(s.player)}</td>
					<td class="num">{s.games}</td><td class="num">{s.kills}</td><td class="num">{s.deaths}</td>
				</tr>)}</tbody>
			</table></div> : <p class="empty">No kills or deaths recorded yet.</p>}
		</div>
	</>;
}
